import React from 'react';
import { Button } from '@cityelectricalfactors/ui-components';
import { cefWhite, information, grey50 } from 'constants/variables';
import { PlusIcon, InfoIcon } from 'assets/common_svgs';
import ApprovalsGroupUser from './approvals_group_user';

const ApprovalsGroupSelectedUsers = ({
  displayText,
  userCount,
  users,
  isValid,
  errorMsg,
  errorRef,
  classes,
  openUserModal,
  openMessageModal,
}) => {
  const { title, description, cta } = displayText;

  const noUsersToRender = userCount === 0;

  const filterSelectedUsers = usersList => {
    return usersList.filter(user => user.selected);
  };

  const selectedUsers = filterSelectedUsers(users);

  return (
    <div className={classes}>
      <h3 className="ff-r fw-700 fs-15 tc-grey-70 lh-1 mb-10">{title}</h3>
      <p className="ff-r fs-14 tc-oa-grey lh-1 mb-10">{description}</p>
      {noUsersToRender && (
        <p className="fl ai-c ff-r fw-700 fs-14 tc-grey-70 lh-1 mb-10 mt-8">
          <InfoIcon width="18" height="18" fillColor={information} />
          <span className="ml-6">
            {`No ${title.slice(0, -1)} roles have been created yet`}
          </span>
        </p>
      )}
      {selectedUsers.length > 0 && (
        <>
          <div className="fl mb-5 pt-5">
            <p className="create-group-users__title ff-r fs-14 tc-grey-70 lh-1 mb-0 ml-12">
              Name
            </p>
            <p className="ff-r fs-14 tc-grey-70 lh-1 mb-0">
              {`${
                title.toLowerCase().includes('user') ? 'Credit' : 'Approval'
              } Limit`}
            </p>
          </div>
          <ul className="create-group-users__wrapper ml-0 mb-12">
            {selectedUsers.map(user => (
              <ApprovalsGroupUser
                key={user.customer_id}
                title={title}
                user={user}
                openMessageModal={openMessageModal}
              />
            ))}
          </ul>
        </>
      )}
      <Button
        className={`${
          noUsersToRender ? 'bg-grey-5 tc-grey-50' : 'bg-cef-red tc-white'
        } ptb-12 plr-14`}
        handleClick={() => openUserModal(title)}
        disabled={noUsersToRender}>
        <PlusIcon
          width="12"
          height="12"
          fillColor={noUsersToRender ? grey50 : cefWhite}
        />
        <span className="ml-8"> {cta}</span>
      </Button>
      {!isValid && (
        <p className="ff-r fs-12 tc-cef-red lh-1 mt-8 mb-18" ref={errorRef}>
          {errorMsg}
        </p>
      )}
    </div>
  );
};

export default ApprovalsGroupSelectedUsers;
